import React from 'react'

const ExternalLink = () => (
  <svg className="icon">
    <use
      xlinkHref={`/Static/Images/icons.svg?=${
        process.env.BUILD_VERSION_ID
      }#icon--external-link`}
    />
  </svg>
)

export default ExternalLink
